export const getChunkLodStep = (chunkDistance: number) => {
  if (chunkDistance <= 2) return 1
  return 2
}

// Average extra underground blocks rendered per full-detail column on top of
// the surface block. Face culling keeps interior blocks invisible, but every
// exposed cliff face / cave wall down to bedrock counts. Sized for steep
// mountain edges and ~30-block-deep terrain.
const UNDERGROUND_BUDGET_PER_COLUMN = 14
const LOD_SKIRT_BUDGET_PER_COLUMN = 10

export const getTerrainRenderCapacity = (
  distance: number,
  chunkSize: number
) => {
  let surfaceSamples = 0
  let fullDetailSamples = 0
  let lodSamples = 0

  for (let chunkX = -distance; chunkX <= distance; chunkX++) {
    for (let chunkZ = -distance; chunkZ <= distance; chunkZ++) {
      const chunkDistance = Math.max(Math.abs(chunkX), Math.abs(chunkZ))
      const lodStep = getChunkLodStep(chunkDistance)
      const samplesPerAxis = Math.ceil(chunkSize / lodStep)
      const samples = samplesPerAxis * samplesPerAxis

      surfaceSamples += samples
      if (lodStep === 1) {
        fullDetailSamples += samples
      } else {
        lodSamples += samples
      }
    }
  }

  return Math.ceil(
    surfaceSamples +
      fullDetailSamples * (UNDERGROUND_BUDGET_PER_COLUMN + 0.95) +
      lodSamples * LOD_SKIRT_BUDGET_PER_COLUMN +
      3000
  )
}
